import React, { useState } from "react";
import { Accordion } from "react-bootstrap";

const Faq = () => {
  const [faqQues] = useState([
    {
      ques: "How To Cancel The Order That I Placed?",
      ans: `Farmerscity.in's Return and Exchange Policy offers no return of goods once delivered. However if you still want to do it you can call us on our missed call number: 0124-4922189 or WhatsApp us on (+91) 9654113661 only before the dispatch.`,
    },
    {
      ques: "How To Create A Return Request?",
      ans: `Farmerscity.in's Return and Exchange Policy offers no return of goods once delivered. You can place a request by giving us a call on 0124-4922189 or whatsApp us on (+91) 9654113661 only before the dispatch.`,
    },
    {
      ques: "How To Check The Status Of My Order?",
      ans: `After placing the order, within 24hrs you will get a msg on your phone number or email id with tracking details, through which you can track the order. If you dont get the msg you can always call us on 0124-4922189 or WhatsApp us on (+91) 9654113661.`,
    },
    {
      ques: "Why There Is A Difference In Selling Price On Farmer’s City And Local Shops?",
      ans: `There is no comparison between Farmer’s City and Local Shops, at Farmer’s City we believe in offering 100% genuine and high quality agri inputs at better prices delivered right at your doorstep. There might or might not be any difference in the selling prices but we make sure we are providing genuine high quality products through our platform.`,
    },
    {
      ques: "Does Farmer’s City Deliver Products Outside The Country?",
      ans: `No, Farmer’s City operates only in India we currently don’t deliver products outside the country.`,
    },
    {
      ques: "I Received A Partial Item/partial Order Or An Untenanted/void Packet. What To Do?",
      ans: `You will receive a Message / IVRS on your number, for multiple orders, If you don’t get the msg you can always call us 0124-4922189 or WhatsApp us on (+91) 9654113661.`,
    },
    {
      ques: "Can I Modify My Order Shipping Address To Which It Will Be Delivered?",
      ans: `You can modify the shipping address only within 1-2 hrs of placing the order because once dispatched it will be difficult for us to change the address. You can also call us on 0124-4922189 or WhatsApp us on (+91) 9654113661 and confirm if your order has already been dispatched because if not than we definitely change it.`,
    },
    {
      ques: "When Will I Receive My Refund For The Order I Cancelled?",
      ans: `Once your return is received and inspected, we will send you an email to notify you that we have received your returned item. We will also notify you of the approval or rejection of your refund. If you are approved, then your refund will be processed, and a credit will automatically be applied to your credit card or original method of payment, within a 7 to 10 Working days.`,
    },
    {
      ques: "How To Create An Account On Farmer’s City?",
      ans: `You can easily login and create your account using your mobile number.`,
    },
    {
      ques: "Where Is Farmer’s City Located?",
      ans: `Farmer’s City is located in Gurugram, Haryana.`,
    },
    {
      ques: "Can My Order Be Replaced?",
      ans: `If your order hasn’t been dispatched yet than you can definitely replace the order. If you choose to exchange the item for reason of mismatch of product or receipt of a defective or expired item, you will be provided with a replacement of the item, free of cost. However an exchange is subject to availability of the product in our stock. You can give us a call on on 0124-4922189 or WhatsApp us on (+91) 9654113661 to check the status of your order before you replace your order.`,
    },
  ]);

  const [activeKey, setActiveKey] = useState("0");

  const handleAccordionToggle = (key) => {
    setActiveKey(activeKey === key ? null : key);
  };

  return (
    <div className="py-5">
      <div className="container px-md-5">
        <h2 className="mb-0 ff_heebo fw-bold fs_6xl clr_dark_green">
          Frequently Asked Questions
        </h2>
        <Accordion className="mt-4" activeKey={activeKey}>
          {faqQues.map((value, index) => (
            <Accordion.Item key={index} eventKey={index.toString()}>
              <Accordion.Header
                onClick={() => handleAccordionToggle(index.toString())}
              >
                {value.ques}
              </Accordion.Header>
              <Accordion.Body>{value.ans}</Accordion.Body>
            </Accordion.Item>
          ))}
        </Accordion>
      </div>
    </div>
  );
};

export default Faq;
